import React from 'react';
import { languageNames } from '../i18n/translations';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const LanguageSelector = ({ currentLang, onLanguageChange, variant = 'default' }) => {
  const currentLanguage = languageNames[currentLang] || languageNames['tr'];
  
  // Dark variant for landing page
  const isDark = variant === 'dark';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className={`gap-2 ${isDark ? 'border-amber-500/50 bg-amber-500/10 text-amber-400 hover:bg-amber-500/20' : ''}`}
          data-testid="language-selector"
        >
          <span className="text-lg">{currentLanguage.flag}</span>
          <span className="hidden sm:inline">{currentLanguage.name}</span>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className={`min-w-[150px] ${isDark ? 'bg-slate-900 border-amber-500/30' : ''}`}
      >
        {Object.entries(languageNames).map(([code, { name, flag }]) => (
          <DropdownMenuItem
            key={code}
            onClick={() => onLanguageChange(code)}
            className={`gap-2 cursor-pointer ${
              isDark 
                ? `text-amber-400 hover:!bg-amber-500/20 focus:!bg-amber-500/20 hover:!text-amber-300 ${currentLang === code ? '!bg-amber-500/30 !text-amber-300' : ''}` 
                : `${currentLang === code ? 'bg-amber-50 text-amber-700' : ''}`
            }`}
          >
            <span className="text-lg">{flag}</span>
            <span>{name}</span>
            {currentLang === code && (
              <svg className={`w-4 h-4 ml-auto ${isDark ? 'text-amber-400' : 'text-amber-600'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;
